import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=36a98e82&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a98e82",
  null
  
)

export default component.exports